/**
 * stores/people.ts
 *
 * Store for the shared actor -> GPerson lookup (personsMap), populated via usePeople().fetchAllPersons
 */

import { defineStore } from 'pinia'
import { ref } from 'vue'
import { usePeople } from '@/composables/usePeople'
import type { ActorId, GPerson, PersonMap } from '@/types/google'
// import { logger } from '@/utils/logger'

export const usePeopleStore = defineStore('people', () => {
    const personsMap = ref<PersonMap>(new Map())

    async function loadPersons (forceReload = false) {
        if (personsMap.value.size > 0 && !forceReload) {
            return
        }
        // logger.log('Loading persons...')
        personsMap.value = await usePeople().fetchAllPersons()
    }

    /**
     * Get a person by actor ID, falling back to a basic placeholder if not (yet) loaded
     */
    function getPerson (id: ActorId): GPerson {
        return personsMap.value.get(id) ?? {
            personId: id,
            displayName: '',
            initials: id.slice(0, 2).toUpperCase(),
            useInitialsAsAvatar: true,
            bgColor: '#CCCCCC',
        }
    }

    function resetState () {
        personsMap.value = new Map()
    }

    return {
        personsMap,
        resetState,
        loadPersons,
        getPerson,
    }
})
